module.exports = __webpack_public_path__ + "static/media/lanshaefismat.f5005d7c.svg";